module.exports = __webpack_public_path__ + "media/images/icons/filled/phone-69b22366d93de29829dfa7249d41e998.svg";